

































































import {Vue, Component} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {Grid} from '@toast-ui/vue-grid';
import {i18nInObjectList} from '@/utils/i18n';
import {popupResize} from '@/utils/ncp';
import {addProductDetailUrlPreview} from '@/utils/formatUtils';
import { convertProductUri } from '@/utils/commonUtils';
@Component({
  components: {CompSelectBox}
})
export default class OtherOptionLoad extends Vue {
  private callback: any = null;
  private mallNo: any = 0;
  private products: any[] = [];
  private standardCategoriesTree: any[] = [];
  private productDetailUrl = '';
  private selectedProductNo = 0;
  private productNo = '';
  private productName = '';
  private category = {
    selectedCategory1: 0,
    selectedCategory2: 0,
    selectedCategory3: 0,
    selectedCategory4: 0
  };
  get standardCategories2() {
    const defaultCategory = {categoryNo: 0, name: '2Depth', child: []};
    if (this.category.selectedCategory1) {
      const finded = this.standardCategoriesTree.find((category) => category.categoryNo === this.category.selectedCategory1);
      if (finded) {
        return [defaultCategory, ...finded.child];
      }
    }
    return [defaultCategory];
  }
  get standardCategories3() {
    const defaultCategory = {categoryNo: 0, name: '3Depth', child: []};
    if (this.category.selectedCategory2) {
      const finded1 = this.standardCategoriesTree.find((category) => category.categoryNo === this.category.selectedCategory1);
      if (finded1) {
        const finded2 = finded1.child.find((category: any) => category.categoryNo === this.category.selectedCategory2);
        if (finded2) {
          return [defaultCategory, ...finded2.child];
        }
      }
    }
    return [defaultCategory];
  }
  get standardCategories4() {
    const defaultCategory = {categoryNo: 0, name: '4Depth', child: []};
    if (this.category.selectedCategory1) {
      const finded1 = this.standardCategoriesTree.find((category) => category.categoryNo === this.category.selectedCategory1);
      if (finded1) {
        const finded2 = finded1.child.find((category: any) => category.categoryNo === this.category.selectedCategory2);
        if (finded2) {
          const finded3 = finded2.child.find((category: any) => category.categoryNo === this.category.selectedCategory3);
          if (finded3) {
            return [defaultCategory, ...finded3.child];
          }
        }
      }
    }
    return [defaultCategory];
  }
  created() {
    this.init();
    this.search();
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.gridProps.options.emptyMessage = this.$t(this.gridProps.options.emptyMessage) as string;
  }
  mounted() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.search(ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });
    /* 선택버튼 클릭 */
    $('body').on('click', '.choiceBtn:not(.dimmed)', this.onClickChoiceBtn);
    this.$nextTick(() => {
      popupResize(1052, 945);
    });
  }
  onClickChoiceBtn(e: Event) {
    const grid = this.$refs.tuiGrid as Grid;

    let rowIndex = 0;
    while (rowIndex <= 9) {
      grid.invoke('removeRowClassName', rowIndex, 'on');
      rowIndex++;
    }

    const rowKey = $(e.target as EventTarget)
      .parents('td')
      .data('rowKey');
    grid.invoke('addRowClassName', rowKey, 'on');
    grid.invoke('focusAt', rowKey, 0, false);
    this.selectedProductNo = this.products[rowKey].productNo;
    this.$forceUpdate();
  }
  onClickConfirmBtn() {
    const optionLength = window.opener.$('#optionList tr:not(.msg_line):not(:hidden)').length;

    if (optionLength > 0) {
      if (!confirm(window.$t('PRODUCT_OPTION_SURE_CALL_DELETE'))) {
        return false;
      }
    }
    if (this.selectedProductNo) {
      $(window.opener.location).attr('href', `javascript:window.${this.callback}(${this.selectedProductNo});`);
    }
    this.close();
  }
  close() {
    window.close();
  }
  init() {
    this.mallNo = Number(this.$route.query.mallNo);
    this.callback = this.$route.query.dataCallback;
    this.searchCategory();
    this.searchProductUrl();
  }
  async searchProductUrl() {
    this.$api
      .getProductsConfiguration({
        params: {mallNo: this.mallNo}
      })
      .then((res) => {
        this.productDetailUrl = addProductDetailUrlPreview(res.data.productDetailUrl);
      });
  }
  searchCategory() {
    this.$api
      .getStandardCategoriesTree({
        params: {
          mallNo: this.mallNo
        }
      })
      .then((ret) => {
        this.standardCategoriesTree = [{categoryNo: 0, name: '1Depth', child: []}, ...ret.data.tree];
      });
  }
  search(page: number = 1) {
    const params: any = {
      mallNo: this.mallNo,
      page,
      size: this.gridProps.options.pageOptions.perPage
    };
    if (this.productNo) {
      params.productNo = this.productNo;
    }
    if (this.productName) {
      params.productName = this.productName;
    }
    if (this.category.selectedCategory1) {
      if (this.category.selectedCategory4) {
        params.standardCategoryViewNo = this.category.selectedCategory4;
      } else if (this.category.selectedCategory3) {
        params.standardCategoryViewNo = this.category.selectedCategory3;
      } else if (this.category.selectedCategory2) {
        params.standardCategoryViewNo = this.category.selectedCategory2;
      } else {
        params.standardCategoryViewNo = this.category.selectedCategory1;
      }
    }
    this.$api.getProductsConfigurable({params}).then(({data}): void => {
      this.products = data.contents;
      this.gridProps.options.pageOptions.totalCount = data.totalCount;
      const grid = this.$refs.tuiGrid as Grid;
      const pagination = grid.invoke('getPagination') as any;
      if (pagination) {
        const pageState = {
          totalCount: this.gridProps.options.pageOptions.totalCount,
          page: this.gridProps.options.pageOptions.page,
          perPage: this.gridProps.options.pageOptions.perPage
        };
        grid.invoke('resetData', this.products as any, {pageState});
      } else {
        grid.invoke('resetData', this.products as any);
      }
    });
    // this.$api.getProductsSearch({params}).then(({data}): void => {
    //   this.products = data.contents;
    //   this.gridProps.options.pageOptions.totalCount = data.totalCount;
    //   const grid = this.$refs.tuiGrid as Grid;
    //   const pagination = grid.invoke('getPagination') as any;
    //   if (pagination) {
    //     const pageState = {
    //       totalCount: this.gridProps.options.pageOptions.totalCount,
    //       page: this.gridProps.options.pageOptions.page,
    //       perPage: this.gridProps.options.pageOptions.perPage
    //     };
    //     grid.invoke('resetData', this.products as any, {pageState});
    //   } else {
    //     grid.invoke('resetData', this.products as any);
    //   }
    // });
  }
  reset() {
    this.productNo = '';
    this.productName = '';
    this.category = {
      selectedCategory1: 0,
      selectedCategory2: 0,
      selectedCategory3: 0,
      selectedCategory4: 0
    };
  }
  resetCategory(depth: number) {
    switch (depth) {
      case 1:
        this.category.selectedCategory2 = 0;
      case 2:
        this.category.selectedCategory3 = 0;
      case 3:
        this.category.selectedCategory4 = 0;
      default:
    }
  }
  private getProductDetailUrl(mallProductNo: any) {
    const uri = convertProductUri(this.productDetailUrl, mallProductNo);
    return `<a target="_blank" href="${uri}" class="mallProductNo" data-mall_product_no="${mallProductNo}">${mallProductNo}</a>`;
  }
  private gridProps = {
    columns: [
      {
        header: 'PRODUCT_OPTION_PRODUCT_NUM',
        name: 'productNo',
        align: 'center',
        minWidth: 100,
        formatter: ({value}: any) => {
          return this.getProductDetailUrl(value);
        }
      },
      {
        header: 'PRODUCT_OPTION_PRODUCT_NAME',
        name: 'productName',
        align: 'left',
        minWidth: 450
      },
      {
        header: 'PRODUCT_OPTION_SELECT',
        align: 'center',
        minWidth: 85,
        formatter: function (cell: any) {
          return `<button class="choiceBtn" data-rowKey="${cell.row.rowKey}">${window.$t('PRODUCT_OPTION_SELECT')}</button>`;
        }
      }
    ],
    options: {
      displayRowCount: 10,
      isInitialRequest: true,
      useClientSort: false,
      emptyMessage: 'PRODUCT_OPTION_TIP_NO_CATEGORY_INFO', // 결과값이 없을 때 출력 메세지
      pageOptions: {
        visiblePages: 5,
        perPage: 10,
        page: 1,
        totalCount: 0
      },
      minRowHeight: 35
    }
  };
}
